import { useCallback } from "react";

export function useSessionDismiss(key: string) {
  const isDismissed =
    typeof window !== "undefined" && sessionStorage.getItem(key) === "true";

  const dismiss = useCallback(() => {
    sessionStorage.setItem(key, "true");
  }, [key]);

  return { isDismissed, dismiss };
}
